// @flow
import React, { PureComponent } from 'react';
import IconButton from 'material-ui/IconButton';
import moment from 'moment';
import FilterBarButton from './FilterBarButton';

export default class MonthSelection extends PureComponent<> {
    setDateRangeForToday = () => {
        const startDate = moment().startOf('month');
        const endDate = moment().endOf('month');
        this.props.onChange({
            endDate,
            startDate
        });
    };

    getPreviousMonthButton = () => {
        const currentDate = this.props.startDate.clone();
        const prevMonth = currentDate.startOf('month').subtract(2, 'days');

        const startDate = prevMonth.clone().startOf('month');
        const endDate = prevMonth.clone().endOf('month');

        const minDate = this.props.minDate;
        const isDisabled = minDate.isAfter(startDate);

        return (
            <IconButton
                onClick={() => this.props.onChange({ endDate, startDate })}
                color="inherit"
                disabled={isDisabled}
            >
                <i className="mdi mdi-chevron-left" />
            </IconButton>
        );
    };

    getNextMonthButton = () => {
        const currentDate = this.props.startDate;
        const nextMonth = currentDate.endOf('month').add(2, 'days');

        const startDate = nextMonth.clone().startOf('month');
        const endDate = nextMonth.clone().endOf('month');

        const isDisabled = startDate.isAfter(moment());

        return (
            <IconButton
                onClick={() => this.props.onChange({ endDate, startDate })}
                color="inherit"
                disabled={isDisabled}
            >
                <i className="mdi mdi-chevron-right" />
            </IconButton>
        );
    };

    getCurrentMonthButton = () => {
        const startDate = this.props.startDate;
        const startDateMonth = startDate.month();
        const startDateYear = startDate.year();
        const currentMonth = moment().month();
        const currentYear = moment().year();

        const hideButton =
            startDateMonth === currentMonth && startDateYear === currentYear;

        if (hideButton) {
            return null;
        }

        return (
            <FilterBarButton onClick={this.setDateRangeForToday.bind()}>
                Current Month
            </FilterBarButton>
        );
    };

    render() {
        const month = this.props.startDate.format('MMMM');
        const year = this.props.startDate.year();
        const currentMonthButton = this.getCurrentMonthButton();
        const prevMonthButton = this.getPreviousMonthButton();
        const nextMonthButton = this.getNextMonthButton();
        return (
            <div className="date-range-container">
                {prevMonthButton}
                <span className="analytics-label">
                    {month} {year}
                </span>
                {nextMonthButton}
                {currentMonthButton}
            </div>
        );
    }
}
